import Microgame from '../engine/Microgame.js';

export default class ShredGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Déchiquette !`, en: `Shred!`, es: `¡Tritura!` },
            controls: { fr: `Fais glisser le papier vers les lames`, en: `Drag the paper towards the blades`, es: `Arrastra el papel hacia las cuchillas` },
            objective: { fr: `Détruis complètement le document secret`, en: `Destroy the secret document completely`, es: `Destruye completamente el documento secreto` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--accent-color)" stroke-width="2"><path d="M4 12V4h16v8"/><path d="M2 12h20v2H2z"/><path d="M6 14v8"/><path d="M10 14v8"/><path d="M14 14v8"/><path d="M18 14v8"/></svg>`,
            actions: [
                { type: 'wait', duration: 220 },
                { type: 'swipe', fromX: 50, fromY: 24, toX: 50, toY: 76, duration: 900 },
                { type: 'wait', duration: 520 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.doc = null;
        this.shredder = null;
        this.startY = 0;
        this.currentY = 0;
        this.isDragging = false;
    }

    setup() {
        this.engine.ui.instruction.textContent = "SHRED!";

        // Shredder Body (Secondary)
        this.shredder = document.createElement('div');
        this.shredder.style.position = 'absolute';
        this.shredder.style.width = '100%';
        this.shredder.style.height = '150px';
        this.shredder.style.background = '#222';
        this.shredder.style.bottom = '0';
        this.shredder.style.borderTop = `5px solid ${this.secondaryColor}`;
        this.shredder.style.zIndex = '2';
        this.shredder.style.boxShadow = `0 -5px 20px ${this.secondaryColor}`;
        this.container.appendChild(this.shredder);

        // Mouth
        const mouth = document.createElement('div');
        mouth.style.position = 'absolute';
        mouth.style.width = '200px';
        mouth.style.height = '20px';
        mouth.style.background = '#000';
        mouth.style.top = '10px';
        mouth.style.left = '50%';
        mouth.style.transform = 'translateX(-50%)';
        mouth.style.borderRadius = '10px';
        this.shredder.appendChild(mouth);

        // Document (Primary)
        this.doc = document.createElement('div');
        this.doc.style.position = 'absolute';
        this.doc.style.width = '180px';
        this.doc.style.height = '250px';
        this.doc.style.background = this.primaryColor;
        this.doc.style.top = '50px';
        this.doc.style.left = '50%';
        this.doc.style.transform = 'translateX(-50%)';
        this.doc.style.boxShadow = `0 0 15px ${this.primaryColor}`;
        this.doc.style.display = 'flex';
        this.doc.style.flexDirection = 'column';
        this.doc.style.padding = '20px';
        this.doc.style.boxSizing = 'border-box';
        this.doc.style.cursor = 'grab';
        this.doc.style.zIndex = '1'; // Behind shredder front, but needs to go IN
        this.container.appendChild(this.doc);

        // Fake text lines
        for (let i = 0; i < 6; i++) {
            const line = document.createElement('div');
            line.style.width = '100%';
            line.style.height = '10px';
            line.style.background = this.secondaryColor;
            line.style.marginBottom = '15px';
            line.style.opacity = '0.5';
            this.doc.appendChild(line);
        }

        this.onDown = this.onDown.bind(this);
        this.onMove = this.onMove.bind(this);
        this.onUp = this.onUp.bind(this);

        this.doc.addEventListener('pointerdown', this.onDown);
        this.engine.input.element.addEventListener('pointermove', this.onMove);
        this.engine.input.element.addEventListener('pointerup', this.onUp);
    }

    onDown(e) {
        if (this.won) return;
        this.isDragging = true;
        this.startY = e.clientY;
        this.doc.style.cursor = 'grabbing';
    }

    onMove(e) {
        if (!this.isDragging || this.won) return;

        const deltaY = e.clientY - this.startY;
        if (deltaY > 0) {
            this.currentY = 50 + deltaY; // 50 is start top
            this.doc.style.top = `${this.currentY}px`;

            // Check if entering shredder
            // Shredder top is at bottom - 150px.
            // Container height ~600. Shredder top ~450.
            // Doc height 250.
            // If Doc Top > 200, it starts entering.

            const rect = this.container.getBoundingClientRect();
            const shredderTop = rect.height - 150;

            if (this.currentY + 250 > shredderTop) {
                // Shredding effect!
                // We can't easily split the DOM element.
                // Visual trick: Hide bottom of doc, spawn strips below.

                if (this.currentY > shredderTop - 50) {
                    this.win();
                    this.doc.style.transition = 'top 0.5s linear';
                    this.doc.style.top = `${rect.height}px`; // Feed rest in
                    this.spawnShreds();
                }
            }
        }
    }

    spawnShreds() {
        for (let i = 0; i < 10; i++) {
            const strip = document.createElement('div');
            strip.style.position = 'absolute';
            strip.style.width = '15px';
            strip.style.height = '50px';
            strip.style.background = this.primaryColor;
            strip.style.bottom = '0';
            strip.style.left = `${50 + (Math.random() * 100 - 50)}%`;
            strip.style.zIndex = '3'; // In front of shredder
            strip.style.boxShadow = `0 0 5px ${this.primaryColor}`;
            this.container.appendChild(strip);

            requestAnimationFrame(() => {
                strip.style.transition = 'all 1s ease-out';
                strip.style.bottom = '-100px';
                strip.style.transform = `rotate(${Math.random() * 360}deg)`;
            });
        }
    }

    onUp() {
        this.isDragging = false;
        this.doc.style.cursor = 'grab';
        if (!this.won) {
            this.doc.style.transition = 'top 0.2s';
            this.doc.style.top = '50px';
            setTimeout(() => this.doc.style.transition = '', 200);
        }
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointermove', this.onMove);
        this.engine.input.element.removeEventListener('pointerup', this.onUp);
    }
}
